// Projects metadata and todos
export const projectsData = [
    {
        id: 'ppap',
        title: 'PPAP',
        subtitle: 'Procrastinating the Procrastination',
        description: '一個幫助對抗拖延症的應用，通過獎勵機制來激勵完成任務。',
        status: 'paused',
        url: 'https://procrastinate-rewards--alan25799.replit.app',
        thumbnail: '/images/ppap-thumbnail.png',
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '完善獎勵機制', completed: false },
            { text: '添加任務分類功能', completed: false },
            { text: '優化用戶界面', completed: false },
            { text: '添加數據統計功能', completed: false }
        ]
    },
    {
        id: 'wildrift-counterpick',
        pinned: true,
        title: 'Wild Rift Counterpick',
        subtitle: '英雄聯盟：激鬥峽谷反制組合輔助工具',
        description: '一個為 Wild Rift 玩家設計的選角反制小工具，快速查找對線剋星與搭配建議，幫助排位時更快做決策。',
        status: 'done',
        url: 'https://b02902131.github.io/wildrift-counterpick/',
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '補上專案截圖與縮圖資產', completed: false },
            { text: '梳理角色／路線分類與資料來源', completed: false },
            { text: '在 Projects 頁面完善介紹文案與 CTA', completed: false },
            { text: '盤點是否需要本地化 (中 / EN)', completed: false },
            { text: '若要長期維護：決定資料更新流程', completed: false }
        ]
    },
    {
        id: 'ighostwriter',
        title: 'iGhostWriter',
        subtitle: '',
        description: 'AI 寫詞工具，支援韻腳典、拖拉放編輯、sync verse、AI 輔助造句、韻腳上色。幫助創作者克服寫作障礙，輕鬆創作優質歌詞。',
        status: 'pending',
        url: null,
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '設計韻腳典數據結構', completed: false },
            { text: '實現拖拉放編輯功能', completed: false },
            { text: '開發 sync verse 功能', completed: false },
            { text: '整合 AI 輔助造句', completed: false },
            { text: '實現韻腳上色功能', completed: false },
            { text: '設計用戶界面', completed: false },
            { text: '建立後端 API', completed: false }
        ]
    },
    {
        id: 'sideprojectlist',
        title: 'Side Project Wish List',
        subtitle: '這個清單也是一個專案',
        description: '本頁展示了我想做與正在做的 side projects —— 其實「side project wish list」這個清單本身，就是我的一個 side project 😆。',
        status: 'wip',
        url: null,
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '建立專案列表頁面', completed: true },
            { text: '實現投票功能', completed: true },
            { text: '整合 Firebase 數據同步', completed: true },
            { text: '添加專案詳細頁面', completed: false },
            { text: '優化移動端顯示', completed: false },
            { text: '允許訪客投稿', completed: false }
        ]
    },
    {
        id: 'website',
        title: 'Personal Website',
        subtitle: '個人網站',
        description: '我的個人作品集網站，展示履歷、音樂創作、專案等內容。',
        status: 'wip',
        url: 'https://kafuka.website',
        coffeeVotes: 0,
        mocktailVotes: 0,
        subProjects: [
            {
                name: '音樂頁面',
                description: '展示音樂創作和播放器的頁面',
                status: 'wip',
                todos: [
                    { text: 'real dj controller', completed: true },
                    { text: 'bpm controller', completed: true },
                    { text: 'high/mid/low cut spin button', completed: true },
                    { text: 'play/stop button', completed: true },
                    { text: '背景加一個 track 滾動的效果', completed: true },
                    { text: '背景 track 滾動效果調深 20%', completed: true },
                    { text: 'sticky cue buttons set', completed: true },
                    { text: '移除底部播放器，只保留 DJ 台', completed: true },
                    { text: 'spotify, soundcloud 卡片寬度優化', completed: true },
                    { text: '添加播放進度條和時間顯示', completed: true },
                    { text: '添加音量控制', completed: true },
                    { text: '添加歌詞顯示區域', completed: true },
                    { text: '國際化：將硬編碼的中文文本改為使用翻譯', completed: true },
                    { text: '修復左右滾動問題', completed: true }
                ]
            }
        ],
        todos: [
            { text: '建立首頁', completed: true },
            { text: '建立履歷頁面', completed: true },
            { text: '建立音樂頁面', completed: true },
            { text: '建立專案列表頁面', completed: true },
            { text: '多國語言支援', completed: true },
            { text: '響應式設計', completed: true },
            { text: '添加更多內容', completed: false },
            { text: '優化性能', completed: false }
        ]
    },
    {
        id: 'blog',
        title: '網誌',
        subtitle: 'Blog',
        description: '個人網誌，記錄生活、技術分享、創作心得等內容。',
        status: 'pending',
        url: null,
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '設計網誌架構', completed: false },
            { text: '建立文章編輯系統', completed: false },
            { text: '實現文章列表頁面', completed: false },
            { text: '實現文章詳情頁面', completed: false },
            { text: '添加分類和標籤功能', completed: false },
            { text: '實現搜尋功能', completed: false },
            { text: '添加 RSS 訂閱', completed: false },
            { text: '優化 SEO', completed: false }
        ]
    },
    {
        id: 'chatbot',
        title: 'Personal Chatbot',
        subtitle: '個人聊天機器人（名字未定）',
        description: '製作一個屬於自己的聊天機器人，可以進行對話、回答問題、協助日常事務等。名字提案：ChatKafka、KafBot、KafukaBot、KafChat、小卡、Kafuka AI、Kafuka Assistant 等。',
        status: 'pending',
        url: null,
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '決定聊天機器人的名字', completed: false },
            { text: '選擇 AI 模型和技術架構', completed: false },
            { text: '設計對話流程和功能', completed: false },
            { text: '建立前端聊天界面', completed: false },
            { text: '開發後端 API 和對話邏輯', completed: false },
            { text: '整合個人知識庫和記憶功能', completed: false },
            { text: '添加多輪對話支持', completed: false },
            { text: '實現個性化設定', completed: false },
            { text: '優化回應速度和準確度', completed: false }
        ]
    },
    {
        id: 'taskdefense',
        title: 'Task Defense Planner',
        subtitle: '工作排程塔防工具',
        description: '一個可以客製化工作排程的工具，結合行事曆與每天的工作清單。任務會以「怪物」的方式呈現，重要度越高的工作就像越大隻、越強的怪獸，在一個塔防遊戲風格的畫面中從右側進場。',
        status: 'pending',
        url: '/task-defense',
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '整理需求：行事曆排程、每日工作清單、怪物／塔防視覺', completed: false }
        ]
    },
    {
        id: 'xiaofenyou',
        title: '小糞遊',
        subtitle: '',
        description: '',
        status: 'pending',
        url: null,
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: []
    },
    {
        id: 'ailrcgenerator',
        title: 'AI LRC Generator',
        subtitle: 'AI 歌詞時間戳生成器',
        description: '使用 AI 自動生成帶時間戳的 LRC 歌詞文件。支持 OpenAI Whisper API 和 Web Speech API，可以從音頻文件和歌詞文本自動對齊生成 LRC 格式的歌詞文件。',
        status: 'wip',
        url: '/lrc-generator',
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '實現 OpenAI Whisper API 整合', completed: true },
            { text: '實現 Web Speech API 備選方案', completed: true },
            { text: '創建 LRC 文件生成工具', completed: true },
            { text: '實現歌詞文本和語音識別結果對齊算法', completed: true },
            { text: '優化對齊算法準確度', completed: false },
            { text: '添加批量處理功能', completed: false },
            { text: '支持更多音頻格式', completed: false },
            { text: '添加手動調整時間戳功能', completed: false }
        ]
    },
    {
        id: 'vibe-ooxx',
        title: '跳脫框架的 OOXX',
        subtitle: 'Tic-Tac-Toe, but the AI cheats',
        description: '一個看似普通的圈圈叉叉遊戲。電腦會正常防守、正常對弈，但在快要平手的時候...它會把棋子下到九宮格外面，延伸連線作弊必勝。Vibe Project #1。',
        status: 'done',
        url: 'https://b02902131.github.io/vibe-ooxx/',
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: []
    },
    {
        id: 'stampmill',
        title: 'StampMill',
        subtitle: 'LINE 貼圖製作工具（fork 強化版）',
        description: '從角色設定 → AI 生成貼圖 → 綠幕去背 → 裁切 → ZIP 打包的一站式 LINE 貼圖工坊。Fork 自 scorpioliu0953/line_sticker_create，新增角色管理、bulk import、表情貼超採樣、綠幕去背、contain 等比下載不裁切等功能。',
        status: 'done',
        url: 'https://b02902131.github.io/line_sticker_create/',
        repo: 'https://github.com/b02902131/line_sticker_create',
        originalRepo: 'https://github.com/scorpioliu0953/line_sticker_create',
        coffeeVotes: 0,
        mocktailVotes: 0,
        todos: [
            { text: '醜馬第三彈 16 張貼圖生成 + 送審', completed: false },
            { text: '狗勾圖鑑 / 喵喵圖鑑 listing 生成', completed: false },
            { text: '單圖重產優化：文字 prompt + 圖文排版參考其他單圖', completed: false }
        ]
    }
];

// Component-specific todos
export const componentTodos = {
    home: [
        '[x] 首頁的多國按鈕放到名字附近',
        '[x] 按下去的時候讓所有元件往左淡出，新的語言的元件從右淡入'
    ],
    music: [
        '[x] real dj controller',
        '    - bpm controller',
        '    - high/mid/low cut spin button',
        '    - play/stop button',
        '[x] 背景加一個 track 滾動的效果參考如圖，從底下往上滾動貫穿頁面但放在最底層，淡一點不要太濃',
        '[x] sticky cue buttons set（頁面滑動上去的時候，超過 DJ 台時下端的按鈕空間黏在 navbar 底下，形同第二層 navbar，案下 CUE button',
        '[x] spotify, soundcloud 卡片的寬度定 314 比較好看',
        '[x] 中間不用簍空',
        '[] ',
        '[x] 不需要左右滾動'
    ],
    projects: [
        '[x] 建立專案列表',
        '[x] 實現投票功能',
        '[x] 整合 Firebase',
        '[] 添加專案詳細頁面',
        '[] 優化移動端顯示'
    ]
};

// Global todos
export const globalTodos = [
    '[] movie review',
    '[x] side project wish list',
    '[x] language',
    '[] 自己的工作排程的工具',
    '[] AI tools',
    '[] dance 🔒'
];

